module.exports = __webpack_public_path__ + "static/img/bg40.3e94ea2c.png";